<template>
    <div class="succeed">
        <div class="qsc-project-list">
            <div class="container">
                <div class="tab-content">
                    <div class="col-md-4"  v-for="(item, index) in succeedList" :key="index">
                      <!-- <div class="succeed-icon"></div> -->
                      <router-link v-bind="{to:'/detail?ChannelId='+item.channel+'&id='+item.raisefund_no}">          
                        <div class="mod-project-card">
                            <div class="front-cover">
                                <img :src="`${item.front_cover}@!thumb.png`" width="100%" alt="项目图片">
                                <span>筹款成功</span>
                            </div>
                            <div class="summary">
                                <h4>{{item.name}}</h4>
                                <p>{{item.summary}}</p>
                                <div class="list">
                                    <ul>
                                        <li><span>筹款目标</span><strong>{{item.raisefunds_number}} <span>元</span></strong></li>
                                        <li><span>已筹金额</span><strong>{{item.accumulative_number}} <span>元</span></strong></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                      </router-link>
                    </div>
                </div>
                <div class="load_more" v-show="hasMore" @click="loadMore">查看更多</div>
                <div v-if="!hasMore" class="no_more">暂无更多</div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      page: '1',
      succeedList:[],
      hasMore: true
    }
  },
  methods:{
    getSucceed() {
      axios.get('https://partner-gateway.qschou.com/official/pc/project/succeed?page=' + this.page).then((res) => {
          res = res.data;
          if (res.code === 0) {
            this.succeedList = this.succeedList.concat(res.data)
            this.page++
            if (res.data.length < 20) {
              this.hasMore = false;
            }
          }
      })
    },
    loadMore () {
      let self = this
      self.getSucceed()
    }
  },
  created () {
    let self = this
    self.getSucceed()
  }
}
</script>

<style lang="less" scoped>
.succeed {
  margin: 30px 0;
  .qsc-project-list {
    position: relative;
    font-size: 14px;
    color: #2B3845;
    .container {
        width: 1200px;
        margin-right: auto;
        margin-left: auto;
      .tab-content {
        display: flex;
        flex-wrap: wrap;
        .col-md-4 {
          position: relative;
          width: 23%;
          position: relative;
          min-height: 1px;
          padding: 0 10px;
          .succeed-icon {
            position: absolute;
            z-index: 10;
            right: 0;
            bottom: 35%;
            // background-image:url('data:image/png;base64,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');
            // background-image:url('data:image/png;base64,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');
            background-size: 100%;
            background-repeat: no-repeat;
            width: 100px;
            height: 100px;
          }
          .mod-project-card{
            background: #fff;
            position: relative;
            margin-bottom: 30px;
            border-radius: 3px;
            box-shadow: 0 5px 20px hsla(0,0%,85%,.5);
            transition: all .3s linear;
            &:hover {
              box-shadow: 0 5px 20px rgba(0,0,0,.3);
            }
            .front-cover{
              height: 210px;
              span{
                position: absolute;
                top: 15px;
                right: 15px;
                z-index: 5;
                border: 1px solid #fff;
                color: #fff;
                padding: 1px 6px;
                border-radius: 10px;
                font-size: 12px;
                font-weight: 600;
                background-color: rgba(0, 0, 0, 0.2);
              }
              img{
                height: 100%;
                width: 100%;
              }
            }
            .summary{
              padding: 15px;
              h4{
                margin: 0;
                font-size: 17px;
                font-weight: 600;
                text-align: left;
                height: 48px;
                overflow: hidden;
                color: #2B3845;
              }
              .list{
                text-align: left;
                position: relative;
                ul{
                  margin: 0;
                  padding: 0;
                  list-style: none;
                  li{
                    height: 32px;
                    line-height: 32px;
                    background: url('data:image/gif;base64,R0lGODlhAwABAJEAAP////f399vb2wAAACH5BAAHAP8ALAAAAAADAAEAAAICjFAAOw==') repeat-x left center;
                    span{
                      background: #fff;
                      color: #6F7A7E;
                      padding-right: 8px;
                    }
                    strong{
                      background: #fff;
                      float: right;
                      padding-left: 8px;
                      padding-right: 0;
                      color: #ed2424;
                      font-weight: 500;
                    }
                  }
                }
              }
              p{
                font-size: 13px;
                color: #999;
                text-align: left;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin: 4px 0 12px 0;
              }
            }
          }
        }
      }
      //加载更多
      .load_more {
        cursor:pointer;
        border: 1px solid #d13c3c;
        border-radius: 6px;
        width: 120px;
        padding: 5px 0;
        margin: 20px auto 0;
        font-size: 18px;
        font-weight: 500;
        color: #d13c3c;
        box-shadow: 0 5px 10px hsla(0,0%,85%,.5);
        transition: all .3s linear;
        &:hover {
          box-shadow: 0 5px 10px rgba(0,0,0,.2);
        }
      }
      .no_more {
        border: 1px solid #999;
        border-radius: 6px;
        width: 120px;
        padding: 5px 0;
        margin: 20px auto 0;
        font-size: 18px;
        font-weight: 500;
        color: #999;
      }
    }
  }
}
</style>

